import React from 'react';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';

import AuthorizedRouteV2 from 'commons-ui/src/permission/AuthorizedRoute';
import { ACTION, MISCELLANEOUS_RESOURCES, PAGE_NAMES } from 'constant';

import InvoiceGenerationList from './submodules/list';

const InvoiceGeneration: React.FC<{}> = () => {
	const { path } = useRouteMatch();
	return (
		<Switch>
			<AuthorizedRouteV2
				configPageName={PAGE_NAMES.miscellaneous}
				configResourceName={MISCELLANEOUS_RESOURCES.invoiceGeneration}
				configActionName={ACTION.fetchBulkInvoice}
				path={`${path}/list`}
				component={InvoiceGenerationList}
			/>
			<Redirect to={`${path}/list`} />
		</Switch>
	);
};

export default InvoiceGeneration;
